import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import { type FC } from 'react'
import { useQueryLabels } from 'src/features/labelMaster/api/useQueryLabels'
import { LabelEditDrawer } from '../../labelEdit/LabelEditDrawer'
import { LabelCard } from './LabelCard'

type Props = {
  labelMasterId: string
  selectedLabelId: string | undefined
  onSelectLabel: (labelId: string) => void
  onDeselectLabel: () => void
}

export const LabelCards: FC<Props> = ({
  labelMasterId,
  selectedLabelId,
  onSelectLabel,
  onDeselectLabel,
}) => {
  const { data, isLoading } = useQueryLabels(labelMasterId)

  if (isLoading) {
    return (
      <Stack
        alignItems="center"
        height="100vh"
        justifyContent="center"
        alignSelf="center"
      >
        <CircularProgress />
      </Stack>
    )
  }

  const labels = data ?? []

  if (labels.length === 0) {
    return (
      <Stack alignItems="center" height={300} justifyContent="center">
        <Typography
          variant="h2"
          sx={{ color: 'text.primary', fontSize: 16, fontWeight: 'bold' }}
        >
          最初のラベルを登録しましょう
        </Typography>
      </Stack>
    )
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(auto-fit, minmax(200px, 1fr))',
          md: 'repeat(auto-fit, minmax(200px, 300px))',
        },
        gap: 2,
      }}
    >
      {labels.map(row => (
        <LabelCard
          key={row.id}
          label={row}
          onClick={() => onSelectLabel(row.id)}
        />
      ))}
      {selectedLabelId && (
        <LabelEditDrawer
          labelMasterId={labelMasterId}
          labelId={selectedLabelId}
          onClose={onDeselectLabel}
        />
      )}
    </Box>
  )
}
